import React, { useCallback, useState } from 'react'
import { Main, MainTop, MainTopTitle, MainTopLeft, MainBody } from '@/components/Layout'
import { useLocalization } from '@/hooks/localization'
import { Row, Col } from 'reactstrap'
import Resx from '@/components/Resx'
import getComponentKey from '@/utils/getComponentKey'
import { CreateChangeItem } from '@/components/changeRequests/createChangeItem'
import { DropDownList } from '@/components/dropDownList'
import context from '@/context'
import { Radio } from '@/components/radio'

function InstitutionSearchList (props) {
  const { renderGrid, title, scope, createNewButtonText } = props
  const [personId, setPersonId] = useState('')
  const [lastReloadedAt, setLastReloadedAt] = useState(getComponentKey)
  const [radioValue, setRadioValue] = useState('institution')

  const { localize } = useLocalization()

  const dropdownChange = useCallback(x => {
    setPersonId(x.value)
    setLastReloadedAt(getComponentKey())
  }, [])

  const radioButtonChange = useCallback(e => {
    setPersonId('')
    setRadioValue(e.target.value)
  }, [])

  return <Main>
    <MainTop>
      <MainTopTitle><Resx name={title} /></MainTopTitle>
      <MainTopLeft>
        <CreateChangeItem buttonText={createNewButtonText} scope={scope} />
      </MainTopLeft>
    </MainTop>
    <MainBody>
      <Row>
        <Radio.Group onChange={radioButtonChange} value={radioValue} style={{ paddingLeft: '10px' }}>
          <Radio value='institution'>{localize('Institutions.Institution')}</Radio>
          <Radio value='individual'>{localize('Individuals.Individual')}</Radio>
        </Radio.Group>
      </Row>
      <Row>
        <Col sm='6'>
          {radioValue === 'individual'
            ? <DropDownList
              dataSource={context.api.individualService.getPersons}
              value={personId || null}
              onChange={dropdownChange} />
            : <DropDownList
              dataSource={context.api.institutionService.getLookupWithPersonId}
              value={personId || null}
              onChange={dropdownChange} />
          }
        </Col>
      </Row>
      <div className='mt-2'>{renderGrid(personId, lastReloadedAt)}</div>
    </MainBody>
  </Main>
}

export {
  InstitutionSearchList
}



// WEBPACK FOOTER //
// ./src/internal-app/components/institutionSearchList.js